import { getImage } from '../../utils';
import { uploadMedia } from '..';
import { SITE_MEDIA_UPLOAD_TYPE } from '../../config';

export const uploadSiteInfoImage =
  (site, key = SITE_MEDIA_UPLOAD_TYPE, desc) =>
  async (blobInfo, success, failure) => {
    try {
      const payload = {
        site,
        mc: desc || blobInfo.filename(),
        [key]: blobInfo.blob(),
      };
      const res = await uploadMedia(payload, {
        endpoint: '/merchant/media/upload',
      });

      const imgSrc = getImage(res.data.result.hash);
      return success(imgSrc);
    } catch (error) {
      failure('مشکلی در هنگام آپلود عکس پیش آمد. لطفا مجددا امتحان کنید.');
    }
  };
